import { EventTrackingDetail } from 'shared/interfaces/marketing/event-tracking-detail.interface';
import { trackFacebookEvent, trackTiktokEvent } from './events';
import { FacebookPixelType, TiktokPixelType } from './types';

export function trackAddToCart(eventData: EventTrackingDetail, facebookPixel: FacebookPixelType, tiktokPixel: TiktokPixelType): void {
	if (!eventData || typeof eventData !== 'object') {
		return;
	}

	const value = Number(eventData.value);
	const monetary = Number.isFinite(value) && value > 0
		? { value, currency: process.env.REACT_APP_CURRENCY }
		: {};

	if (facebookPixel.active && facebookPixel.eventAddToCart) {
		trackFacebookEvent('AddToCart', {
			content_name: eventData.name,
			contents: [eventData],
			...monetary
		});
	}

	if (tiktokPixel.active && tiktokPixel.eventAddToCart) {
		trackTiktokEvent('AddToCart', {
			contents: [{
				content_id: eventData.id,
				content_type: 'product',
				content_name: eventData.name
			}],
			...monetary
		});
	}
}
